import { JSONStringifyReplacer } from './utils';
import { NewsletterFrequency } from '../../../const';

export const INITIAL_CONFIG_LIST = [{}];
export const MAIN_TITLE = 'Automatisation de la newsletter';

export const DAYS_FREQUENCY_OPTIONS = Object.entries(
  NewsletterFrequency,
).map(([value, label]) => ({ value, label }));

export const JSON_STRINGIFY_OPTS = {
  replacer: (_: string, value: Record<string, unknown>) =>
    JSONStringifyReplacer(_, value),
  space: 2,
  quote: '"',
};
